import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Globals, Reset } from '@icecreamsocial/components';
import ThemeProvider from './providers/ThemeProvider';
import GTagProvider from './providers/GTagProvider';
import { Main } from './views/Main';
import { Snackbar } from './presentational';
import { FlavorLayout } from './container';
import { StoreProvider, usePostMessage } from './hooks';
import Initializer from './container/Initializer';

const MEASUREMENT_ID = process.env.GA4_MEASUREMENT_ID;

const CampaignReferral = () => {
	return (
		<GTagProvider measurementId={MEASUREMENT_ID}>
			<Initializer />
		</GTagProvider>
	);
};
export default observer(CampaignReferral);
